function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import SelectionSection from "./components/selection-section";
import TabBar from "./components/tab-bar";
import Cards from "./components/cards";
import getFromDictionary from "./utils/dictionary";
import mapResults from "./utils/mapResults";
import postProcessData from "./utils/postProcessData";
import Loader from "@demant/product-experience-page/lib/visual-oticon/modules/PEP-loader/js/PepLoaderAnimated";
import Chips from "./components/chips";
var App = function App(_ref) {
  var settings = _ref.settings,
    loadContent = _ref.loadContent;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    filteredData = _useState2[0],
    setFilteredData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    allData = _useState4[0],
    setAllData = _useState4[1];
  var _useState5 = useState({
      product: 0,
      device: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedIds = _useState6[0],
    setSelectedIds = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showIncompatible = _useState8[0],
    setShowIncompatible = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showDirectStreaming = _useState0[0],
    setDirectStreaming = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showTwoWayStreaming = _useState10[0],
    _setTwoWayStreaming = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoading = _useState12[0],
    setIsLoading = _useState12[1];
  var _useState13 = useState(window.location),
    _useState14 = _slicedToArray(_useState13, 2),
    loadUrl = _useState14[0],
    setLoadUrl = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedProductId = _useState16[0],
    setSelectedProductId = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedDeviceId = _useState18[0],
    setSelectedDeviceId = _useState18[1];
  var _useState19 = useState(),
    _useState20 = _slicedToArray(_useState19, 2),
    contentLoading = _useState20[0],
    setContentLoading = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    contentLoaded = _useState22[0],
    setContentLoaded = _useState22[1];
  var selectDeviceDictionary = settings.elements[1];
  var tabBar = settings.elements[2];
  var cardDictionary = settings.elements[3];
  var delay;
  useEffect(function () {
    if (!contentLoading) {
      return;
    }
    setIsLoading(true);
    contentLoading.then(function (result) {
      setContentLoaded(true);
      var mappedResults = mapResults(result);
      for (var i = 0; i < mappedResults.accessories.length; i++) {
        if (mappedResults.accessories[i].title !== null) {
          if (mappedResults.accessories[i].title.includes("SafeLine")) {
            mappedResults.accessories.splice(i, 1);
          }
        }
      }
      setFilteredData(postProcessData(mappedResults, selectedIds.product, selectedIds.device));
      if (!allData) {
        setAllData(mappedResults);
        getFiltersFromUrl(mappedResults);
      }
      setIsLoading(false);
    }).catch(function (reason) {
      console.log(reason);
    });
  }, [contentLoading]);
  var resetAllData = function resetAllData() {
    if (allData) {
      Object.keys(allData).forEach(function (dataType) {
        allData[dataType].forEach(function (data) {
          delete data.compatible;
        });
      });
    }
  };
  var createFilterUrl = function createFilterUrl() {
    if (!window.location) return;
    if (history.replaceState) {
      var filterQueries = [];
      if (filteredData) {
        Object.keys(filteredData).forEach(function (dataType) {
          filteredData[dataType].forEach(function (data) {
            if (selectedIds.device === data.id) {
              filterQueries.push(data.title);
            }
            if (selectedIds.product === data.id) {
              filterQueries.push("".concat(data.title, " ").concat(data.subTitle));
            }
          });
        });
      }
      if (showDirectStreaming) {
        filterQueries.push("directStreaming:".concat(showDirectStreaming));
      }
      if (showTwoWayStreaming) {
        filterQueries.push("twoWayStreaming:".concat(showTwoWayStreaming));
      }
      if (showIncompatible) {
        filterQueries.push("showIncompatible:".concat(showIncompatible));
      }
      if (filterQueries.length === 0 && loadUrl) {
        return;
      }
      var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(filterQueries.length ? "?filters=".concat(filterQueries.join(";")) : "");
      window.history.pushState({}, document.title, newurl);
    }
  };
  var getFiltersFromUrl = function getFiltersFromUrl(data) {
    if (!loadUrl) return {};
    var regex = new RegExp("[\\?&]filters=([^&#]*)");
    var results = regex.exec(loadUrl.search);
    var filterQuery = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    var filters = filterQuery.split(";");
    if (filters) {
      var tempSelectedIds = _objectSpread({}, selectedIds);
      filters.forEach(function (filter) {
        data.devices.forEach(function (device) {
          if (filter === device.title) {
            tempSelectedIds.device = device.id;
          }
        });
        data.products.forEach(function (product) {
          if (filter === "".concat(product.title, " ").concat(product.subTitle)) {
            tempSelectedIds.product = product.id;
          }
        });
        if (filter === "directStreaming:true") {
          setDirectStreaming(true);
        }
        if (filter === "twoWayStreaming:true") {
          _setTwoWayStreaming(true);
        }
        if (filter === "showIncompatible:true") {
          setShowIncompatible(true);
        }
      });
      setSelectedIds(tempSelectedIds);
    }
    setLoadUrl(null);
  };
  useEffect(function () {
    resetAllData();
    var params = {};
    if (selectedIds.product) {
      params.ProductId = selectedIds.product;
    }
    if (selectedIds.device) {
      params.DeviceId = selectedIds.device;
    }
    params.Market = document.querySelector("html").getAttribute("lang").replace("en", "en-US");
    if (!contentLoaded || params.ProductId || params.DeviceId) {
      setContentLoading(loadContent(params));
    }
  }, [selectedIds]);
  var handleSelectionChange = function handleSelectionChange(selectedProdId, selectedDevId) {
    if (loadUrl) {
      return;
    }
    clearTimeout(delay);
    delay = setTimeout(function () {
      setSelectedIds({
        product: selectedProdId,
        device: selectedDevId
      });
    }, 500);
  };
  var dataToShow = function () {
    createFilterUrl();
    var output = {
      accessories: [],
      apps: [],
      devices: [],
      products: []
    };
    if (!filteredData) {
      return output;
    }
    if ((!showDirectStreaming || !showTwoWayStreaming) && (selectedIds.device || selectedIds.product)) {
      Object.keys(filteredData).forEach(function (dataType) {
        filteredData[dataType].forEach(function (data) {
          data.compatible = true;
        });
      });
    }
    if (showDirectStreaming && !showTwoWayStreaming) {
      Object.keys(output).forEach(function (dataType) {
        var direct = [];
        filteredData[dataType].forEach(function (item) {
          if (item.directStreaming === true) {
            direct.push(item);
          }
          if ((dataType === "devices" || dataType === "products") && item.directStreaming === false) {
            item.compatible = false;
          }
          if (dataType === "apps") {
            direct.push(item);
          }
          if (dataType === "accessories") {
            direct.push(item);
          }
          if (item.directStreaming === null && (selectedIds.device === item.id || selectedIds.product === item.id)) {
            direct.push(item);
          }
        });
        output[dataType] = [].concat(direct);
      });
    }
    if (showTwoWayStreaming) {
      Object.keys(output).forEach(function (dataType) {
        var twoWay = [];
        filteredData[dataType].forEach(function (item) {
          var hasTwoWayStreaming = item.lea2Compatibility || item.lea2Support;
          if (hasTwoWayStreaming) {
            twoWay.push(item);
          }
          if ((dataType === "devices" || dataType === "products") && !hasTwoWayStreaming) {
            item.compatible = false;
          }
          if (dataType === "apps") {
            twoWay.push(item);
          }
          if (dataType === "accessories") {
            twoWay.push(item);
          }
        });
        output[dataType] = [].concat(twoWay);
      });
    }
    if (!showIncompatible || !selectedIds.product && !selectedIds.device) {
      resetAllData();
      return showDirectStreaming || showTwoWayStreaming ? output : filteredData;
    }
    if (allData) {
      Object.keys(output).forEach(function (dataType) {
        var incompatible = [];
        var compatible = showDirectStreaming || showTwoWayStreaming ? output[dataType] : filteredData[dataType];
        filteredData[dataType].forEach(function (item) {
          if (!compatible.find(function (element) {
            return element.id === item.id;
          })) {
            incompatible.push(item);
          }
        });
        allData[dataType].forEach(function (item) {
          if (!compatible.find(function (element) {
            return element.id === item.id;
          }) && !incompatible.find(function (element) {
            return element.id === item.id;
          })) {
            incompatible.push(item);
          }
        });
        incompatible.forEach(function (item) {
          item.compatible = false;
        });
        output[dataType] = [].concat(_toConsumableArray(compatible), incompatible);
      });
    }
    return output;
  }();
  var setElementLabel = function setElementLabel(data, elementId, showIncompatibleInLabel) {
    if (data.find(function (el) {
      return el.id === elementId && data.find(function (el) {
        return el.compatible === true;
      });
    })) {
      return showIncompatibleInLabel ? "1/1 ".concat(getFromDictionary("areCompatible", cardDictionary)) : "1";
    }
    return showIncompatibleInLabel ? "0/1 ".concat(getFromDictionary("areCompatible", cardDictionary)) : "0";
  };
  var getLabelForDataType = function getLabelForDataType(dataType, showIncompatibleInLabel) {
    if (!filteredData) {
      return 0;
    }
    if (showDirectStreaming && !showTwoWayStreaming) {
      var direct = [];
      for (var i = 0; i < filteredData[dataType].length; i++) {
        if (filteredData[dataType][i].directStreaming === true) {
          direct.push(filteredData[dataType][i]);
        }
        if (dataType === "apps") {
          direct.push(filteredData[dataType][i]);
        }
        if (dataType === "accessories") {
          direct.push(filteredData[dataType][i]);
        }
      }
      if (selectedIds.product) {
        if (dataType === "products") {
          return setElementLabel(filteredData[dataType], selectedIds.product, showIncompatibleInLabel);
        }
      }
      if (selectedIds.device) {
        if (dataType === "devices") {
          return setElementLabel(filteredData[dataType], selectedIds.device, showIncompatibleInLabel);
        }
      }
      return showIncompatibleInLabel ? "".concat(direct.length, "/").concat(allData[dataType].length, " ").concat(getFromDictionary("areCompatible", cardDictionary)) : "".concat(direct.length);
    }
    if (showTwoWayStreaming) {
      var twoWay = [];
      for (var _i = 0; _i < filteredData[dataType].length; _i++) {
        var item = filteredData[dataType][_i];
        if (item !== null && item !== void 0 && item.lea2Compatibility || item !== null && item !== void 0 && item.lea2Support || selectedIds.product === item.id) {
          twoWay.push(item);
        }
        if (dataType === "apps") {
          twoWay.push(item);
        }
        if (dataType === "accessories") {
          twoWay.push(item);
        }
      }
      ;
      // when data has only one product which is also selected as filter then show this product as compatibility
      // below logic is needed to fix data
      var compatibleProductCounter = twoWay === null || twoWay === void 0 ? void 0 : twoWay.length;
      return showIncompatibleInLabel ? "".concat(compatibleProductCounter, "/").concat(allData[dataType].length, " ").concat(getFromDictionary("areCompatible", cardDictionary)) : "".concat(compatibleProductCounter);
    }
    if (selectedIds.product) {
      if (dataType === "products") {
        return setElementLabel(filteredData[dataType], selectedIds.product, showIncompatibleInLabel);
      }
    }
    if (selectedIds.device) {
      if (dataType === "devices") {
        var label = setElementLabel(filteredData[dataType], selectedIds.device, showIncompatibleInLabel);
        return label;
      }
    }
    if (!showIncompatibleInLabel || !selectedIds.product && !selectedIds.device) {
      return filteredData[dataType].length;
    }
    return "".concat(filteredData[dataType].length, "/").concat(allData[dataType].length, " ").concat(getFromDictionary("areCompatible", cardDictionary));
  };
  var getNoResultTag = function getNoResultTag(noResTag) {
    var dictionary;
    var link;
    var title;
    cardDictionary.items.forEach(function (el) {
      if (el.type === "link") {
        link = el.link.href;
        title = el.link.content;
      }
    });
    return dictionary = {
      noResult: getFromDictionary(noResTag, cardDictionary),
      compatible: getFromDictionary("compatible", cardDictionary),
      incompatible: getFromDictionary("incompatible", cardDictionary),
      showAll: getFromDictionary("showAll", cardDictionary),
      hide: getFromDictionary("hide", cardDictionary),
      telVsBlue: getFromDictionary("telVsBlue", cardDictionary),
      later: getFromDictionary("orLater", cardDictionary),
      requireIos: getFromDictionary("requiresIos", cardDictionary),
      requireAndroid: getFromDictionary("requiresAndroid", cardDictionary),
      noDirectStreaming: getFromDictionary("noDirectStreaming", cardDictionary),
      requireIntermediary: getFromDictionary("requireIntermediary", cardDictionary),
      learnMore: {
        link: link,
        title: title
      }
    };
  };
  var devices = dataToShow.devices.map(function (d) {
    var _d$title;
    var phoneName = (d === null || d === void 0 || (_d$title = d.title) === null || _d$title === void 0 || (_d$title = _d$title.split(" ")[0]) === null || _d$title === void 0 ? void 0 : _d$title.replace(/[0-9]/g, "")) || "default";
    var image = "https://assets-we.cas.dgs.com/-/media/oticon/main/Images/logos/".concat(d.isIOSDevice ? "apple" : phoneName, "-logo-phone-tablet.png");
    return _objectSpread(_objectSpread({}, d), {}, {
      imageLink: image
    });
  });
  var selectedProduct = allData && [allData.products, allData.devices][0].filter(function (product) {
    return product.id === selectedProductId;
  }).shift();
  var selectedDevice = allData && [allData.products, allData.devices][1].filter(function (device) {
    return device.id === selectedDeviceId;
  }).shift();
  return /*#__PURE__*/React.createElement("div", {
    className: "cg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__section"
  }, settings.preElementItems.map(function (element) {
    return /*#__PURE__*/React.createElement("div", {
      key: element.html.html,
      dangerouslySetInnerHTML: {
        __html: element.html.html
      }
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cg__selection"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__section ".concat(allData ? "fetched" : "")
  }, allData && /*#__PURE__*/React.createElement(SelectionSection, {
    elements: settings.elements,
    data: [allData.products, allData.devices],
    onChange: handleSelectionChange,
    showDirect: showDirectStreaming,
    setTwoWayStreaming: function setTwoWayStreaming() {
      return _setTwoWayStreaming(function (prev) {
        return !prev;
      });
    },
    showTwoWayStreaming: showTwoWayStreaming,
    setDirect: function setDirect() {
      return setDirectStreaming(!showDirectStreaming);
    },
    selectDeviceDictionary: selectDeviceDictionary,
    disableDirectStreaming: selectedIds.product || selectedIds.device,
    urlSelectedDeviceId: selectedIds.device,
    urlSelectedProductId: selectedIds.product,
    selectedProductId: selectedProductId,
    setSelectedProductId: setSelectedProductId,
    selectedDeviceId: selectedDeviceId,
    setSelectedDeviceId: setSelectedDeviceId
  }))), (selectedProduct || selectedDevice) && /*#__PURE__*/React.createElement(Chips, {
    selectedProduct: selectedProduct,
    selectedDevice: selectedDevice,
    showDirect: showDirectStreaming,
    selectDeviceDictionary: selectDeviceDictionary,
    showTwoWayStreaming: showTwoWayStreaming,
    selectedProductId: selectedProductId,
    setSelectedProductId: setSelectedProductId,
    selectedDeviceId: selectedDeviceId,
    setSelectedDeviceId: setSelectedDeviceId,
    setContentLoaded: setContentLoaded,
    setDirect: function setDirect() {
      return setDirectStreaming(!showDirectStreaming);
    },
    settings: settings,
    setTwoWayStreaming: function setTwoWayStreaming() {
      return _setTwoWayStreaming(function (prev) {
        return !prev;
      });
    },
    setShowIncompatible: setShowIncompatible,
    showIncompatible: showIncompatible
  }), /*#__PURE__*/React.createElement("div", {
    className: "cg__result ".concat(!isLoading ? "fetched" : "")
  }, isLoading ? /*#__PURE__*/React.createElement(Loader, {
    controlLoader: true,
    stopLoader: !isLoading
  }) : null, !isLoading && /*#__PURE__*/React.createElement("div", {
    className: "cg__section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__tab-bar-container"
  }, /*#__PURE__*/React.createElement(TabBar, {
    tabs: [{
      link: "#result1",
      label: "".concat(getFromDictionary("hearingAidsTabBar", tabBar), " (").concat(getLabelForDataType("products"), ")")
    }, {
      link: "#result2",
      label: "".concat(getFromDictionary("accessoriesTabBar", tabBar), " (").concat(getLabelForDataType("accessories"), ")")
    }, {
      link: "#result3",
      label: "".concat(getFromDictionary("appsTabBar", tabBar), " (").concat(getLabelForDataType("apps"), ")")
    }, {
      link: "#result4",
      label: "".concat(getFromDictionary("devicesTabBar", tabBar), " (").concat(getLabelForDataType("devices"), ")")
    }]
  }), (selectedIds.product !== 0 || selectedIds.device !== '') && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "cg__checkbox-button ".concat(showIncompatible ? "cg__checkbox-button--selected" : ""),
    onClick: function onClick() {
      return setShowIncompatible(!showIncompatible);
    }
  }, getFromDictionary("showIncompatible", tabBar))), /*#__PURE__*/React.createElement("div", {
    id: "result1"
  }, /*#__PURE__*/React.createElement("h4", null, "".concat(getFromDictionary("hearingAids", cardDictionary), " (").concat(getLabelForDataType("products", true), ")")), /*#__PURE__*/React.createElement(Cards, {
    type: "products",
    results: dataToShow.products,
    selectedId: selectedIds.product,
    areSelected: selectedIds.device && selectedIds.product,
    isSelected: selectedIds.device || selectedIds.product ? true : false,
    dictionary: getNoResultTag("hearingAidsNoResult")
  })), /*#__PURE__*/React.createElement("div", {
    id: "result2"
  }, /*#__PURE__*/React.createElement("h4", null, "".concat(getFromDictionary("accessories", cardDictionary), " (").concat(getLabelForDataType("accessories", true), ")")), /*#__PURE__*/React.createElement(Cards, {
    type: "accessories",
    results: dataToShow.accessories,
    selectedId: 0,
    dictionary: getNoResultTag("accessoriesNoResult")
  })), /*#__PURE__*/React.createElement("div", {
    id: "result3"
  }, /*#__PURE__*/React.createElement("h4", null, "".concat(getFromDictionary("apps", cardDictionary), " (").concat(getLabelForDataType("apps", true), ")")), /*#__PURE__*/React.createElement(Cards, {
    type: "apps",
    results: dataToShow.apps,
    selectedId: 0,
    dictionary: getNoResultTag("appsNoResult")
  })), /*#__PURE__*/React.createElement("div", {
    id: "result4"
  }, /*#__PURE__*/React.createElement("h4", null, "".concat(getFromDictionary("devices", cardDictionary), " (").concat(getLabelForDataType("devices", true), ")")), /*#__PURE__*/React.createElement(Cards, {
    type: "devices",
    results: devices,
    selectedId: selectedIds.device,
    areSelected: selectedIds.device && selectedIds.product,
    dictionary: getNoResultTag("devicesNoResult")
  })))));
};
export default App;